<template>
  <div class="formc">
    <div class="formc-con">
      <el-form :model="data" :rules="rules" ref="elFormRef" inline-message scroll-to-error :scroll-into-view-options="{ behavior: 'smooth', block: 'center' }">
        <table class="el-table-s4">
          <tbody>
            <tr>
              <td colspan="2" class="table-label" width="236" height="40">
                <span>城镇职工基本养老保险（单位：人)</span>
              </td>
              <td colspan="2" width="190">
                <div class="td-c1">
                  <el-form-item prop="so110">
                    <el-input v-model.trim="data.so110" />
                  </el-form-item>
                </div>
              </td>
              <td class="table-label" width="256">
                <span>失业保险（单位：人)</span>
              </td>
              <td>
                <div class="td-c1">
                  <el-form-item prop="so210">
                    <el-input v-model.trim="data.so210" />
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="2" class="table-label" width="236" height="40">
                <span>职工基本医疗保险（单位：人)</span>
              </td>
              <td colspan="2" width="190">
                <div class="td-c1">
                  <el-form-item prop="so310">
                    <el-input v-model.trim="data.so310" />
                  </el-form-item>
                </div>
              </td>
              <td class="table-label" width="256">
                <span>工伤保险（单位：人)</span>
              </td>
              <td>
                <div class="td-c1">
                  <el-form-item prop="so410">
                    <el-input v-model.trim="data.so410" />
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="2" class="table-label" width="236" height="40">
                <span>生育保险（单位：人)</span>
              </td>
              <td colspan="2" width="190">
                <div class="td-c1">
                  <el-form-item prop="so510">
                    <el-input v-model.trim="data.so510" />
                  </el-form-item>
                </div>
              </td>
            </tr>

            <!-- 单位缴费基数 -->
            <tr>
              <td rowspan="4" class="table-label" width="118">
                <p>单位缴费基数</p>
              </td>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加城镇职工基本养老保险缴费基数</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalwagesSo110">
                    <el-input v-model.trim="data.totalwagesSo110" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td rowspan="4">
                <div class="td-c1">
                  <el-form-item prop="totalwagesdis">
                    <el-radio-group v-model="data.totalwagesdis">
                      <el-radio value="1">选择公示</el-radio>
                      <el-radio value="2">选择不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加失业保险缴费基数</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalwagesSo210">
                    <el-input v-model.trim="data.totalwagesSo210" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加职工基本医疗保险缴费基数</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalwagesSo310">
                    <el-input v-model.trim="data.totalwagesSo310" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加生育保险缴费基数</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalwagesSo510">
                    <el-input v-model.trim="data.totalwagesSo510" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>
            <!-- 单位缴费基数 -->

            <!-- 本期实际缴费金额	-->
            <tr>
              <td rowspan="5" class="table-label" width="118">
                <p>本期实际缴费金额</p>
              </td>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>参加城镇职工基本养老保险本期实际缴费金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalpaymentSo110">
                    <el-input v-model.trim="data.totalpaymentSo110" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td rowspan="5">
                <div class="td-c1">
                  <el-form-item prop="totalpaymentdis">
                    <el-radio-group v-model="data.totalpaymentdis">
                      <el-radio value="1">选择公示</el-radio>
                      <el-radio value="2">选择不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>参加失业保险本期实际缴费金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalpaymentSo210">
                    <el-input v-model.trim="data.totalpaymentSo210" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>参加职工基本医疗保险本期实际缴费金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalpaymentSo310">
                    <el-input v-model.trim="data.totalpaymentSo310" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>参加工伤保险本期实际缴费金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalpaymentSo410">
                    <el-input v-model.trim="data.totalpaymentSo410" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>参加生育保险本期实际缴费金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="totalpaymentSo510">
                    <el-input v-model.trim="data.totalpaymentSo510" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>
            <!-- 本期实际缴费金额 -->

            <!-- 单位累计欠缴金额 -->
            <tr>
              <td rowspan="5" class="table-label" width="118">
                <p>单位累计欠缴金额</p>
              </td>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加城镇职工基本养老保险累计欠缴金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="unpaidsocialinsSo110">
                    <el-input v-model.trim="data.unpaidsocialinsSo110" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
              <td rowspan="5">
                <div class="td-c1">
                  <el-form-item prop="unpaidsocialinsdis">
                    <el-radio-group v-model="data.unpaidsocialinsdis">
                      <el-radio value="1">选择公示</el-radio>
                      <el-radio value="2">选择不公示</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加失业保险累计欠缴金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="unpaidsocialinsSo210">
                    <el-input v-model.trim="data.unpaidsocialinsSo210" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加职工基本医疗保险累计欠缴金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="unpaidsocialinsSo310">
                    <el-input v-model.trim="data.unpaidsocialinsSo310" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加工伤保险累计欠缴金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="unpaidsocialinsSo410">
                    <el-input v-model.trim="data.unpaidsocialinsSo410" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="3" class="table-label" width="300" height="40">
                <span>单位参加生育保险累计欠缴金额</span>
              </td>
              <td>
                <div class="td-c2">
                  <el-form-item prop="unpaidsocialinsSo510">
                    <el-input v-model.trim="data.unpaidsocialinsSo510" />
                  </el-form-item>

                  <span>万元</span>
                </div>
              </td>
            </tr>
            <!-- 单位累计欠缴金额 -->
          </tbody>
        </table>
      </el-form>
    </div>

    <div class="formc-btn">
      <el-button type="primary" color="#d1ab62" size="large" @click="save">保存</el-button>
      <el-button type="primary" color="#d1ab62" size="large" @click="emits('emit', 'gotoPage', 'center')">返回</el-button>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep } from "lodash";

const props = defineProps({
  data: {
    type: Object,
    defaults() {
      return {};
    },
  },
});

const elFormRef = ref();

const data = ref({});

const rulesConfig = { required: true, trigger: ["blur", "change"], message: "不能为空" };

const rules = ref({
  so110: [rulesConfig],
  so210: [rulesConfig],
  so310: [rulesConfig],
  so410: [rulesConfig],
  so510: [rulesConfig],
  totalwagesSo110: [rulesConfig],
  totalwagesSo210: [rulesConfig],
  totalwagesSo310: [rulesConfig],
  totalwagesSo510: [rulesConfig],
  totalwagesdis: [rulesConfig],
  totalpaymentSo110: [rulesConfig],
  totalpaymentSo210: [rulesConfig],
  totalpaymentSo310: [rulesConfig],
  totalpaymentSo410: [rulesConfig],
  totalpaymentSo510: [rulesConfig],
  totalpaymentdis: [rulesConfig],
  unpaidsocialinsSo110: [rulesConfig],
  unpaidsocialinsSo210: [rulesConfig],
  unpaidsocialinsSo310: [rulesConfig],
  unpaidsocialinsSo410: [rulesConfig],
  unpaidsocialinsSo510: [rulesConfig],
  unpaidsocialinsdis: [rulesConfig],
});

const save = () => {
  elFormRef.value.validate((isValid) => {
    if (isValid) {
      emits("emit", "submit", data.value);
    }
  });
};

const emits = defineEmits(["emit"]);

onMounted(() => {
  data.value = cloneDeep(props.data);
});
</script>

<style lang="scss" scoped>
.formc {
}
</style>
